import { APPLIED_SINGLE_FILTER_WORKOUTS } from './actionTypes'

export default (selectedFilterObject, selectedFilterName) => ({
  type: APPLIED_SINGLE_FILTER_WORKOUTS,
  payload: {
    selectedFilterObject,
    selectedFilterName
  }
})